import Inst from './src/ContextMenuInstance'
export * from './src/ContextMenu.vue'
export * from './src/ContextMenuItem.vue'
export * from './src/ContextMenuGroup.vue'
export * from './src/ContextMenuSperator.vue'
export * from './src/ContextSubMenu.vue'

export default Inst